import { ApiPaths } from 'api/constants';
import { ProcessGeneral } from 'api/endpoints/processes';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import {
  FtpPollingScenarioDetails,
  FtpPollingScenarioGeneral,
  FtpScenarioOptions,
  IFtpRepo,
} from './IFtp';

export class FtpRepo extends BaseRepo implements IFtpRepo {
  getScenarioDetails(
    releaseOrDraftProcessId: string,
    scenarioId: string
  ): ApiResponseAsync<FtpPollingScenarioDetails> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: releaseOrDraftProcessId,
      [ApiUrlParams.ftpPollingScenarioId]: scenarioId,
    });

    return this.helpers.handleGet(link);
  }
  deleteScenario(
    draft: ProcessGeneral,
    scenario: FtpPollingScenarioGeneral
  ): ApiResponseAsync<void> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.ftpPollingScenarioId]: scenario.id,
    });

    return this.helpers.handleDelete(link);
  }
  getScenarios(
    releaseOrDraftProcessId: string
  ): ApiResponseAsync<DataWithTotal<FtpPollingScenarioGeneral>> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios._({
      [ApiUrlParams.releaseOrDraftProcessId]: releaseOrDraftProcessId,
    });

    return this.helpers.handleGet(link);
  }
  createScenario(
    draft: ProcessGeneral,
    options: FtpScenarioOptions
  ): ApiResponseAsync<FtpPollingScenarioDetails> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
    });

    return this.helpers.handlePost(link, options);
  }
  updateScenario(
    draft: ProcessGeneral,
    scenario: FtpPollingScenarioGeneral,
    options: FtpScenarioOptions
  ): ApiResponseAsync<FtpPollingScenarioDetails> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios.byId._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.ftpPollingScenarioId]: scenario.id,
    });

    return this.helpers.handlePut(link, options);
  }
  activateScenario(
    draft: ProcessGeneral,
    scenario: FtpPollingScenarioGeneral
  ): ApiResponseAsync<void> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios.byId.activate._({
      [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
      [ApiUrlParams.ftpPollingScenarioId]: scenario.id,
    });

    return this.helpers.handlePostAction(link, {});
  }
  deactivateScenario(
    draft: ProcessGeneral,
    scenario: FtpPollingScenarioGeneral
  ): ApiResponseAsync<void> {
    const link = ApiPaths.processes.byId.ftpPolling.scenarios.byId.deactivate._(
      {
        [ApiUrlParams.releaseOrDraftProcessId]: draft.id,
        [ApiUrlParams.ftpPollingScenarioId]: scenario.id,
      }
    );

    return this.helpers.handlePostAction(link, {});
  }
}
